///
/// EarthBrowser
///
/// Created by Matt Giger on 2/15/2026
/// Copyright (c) 2026 Geodata Labs
///

import { Renderer } from "@stovokor/engine/Renderer"
import { RenderState } from "@stovokor/engine/RenderState"
import { type matrix } from "@stovokor/math/matrix"
import { type vec3 } from "@stovokor/math/vector"
import { type Geometry } from "@stovokor/shader/Geometry"
import { type Material } from "@stovokor/shader/Material"
import { ShaderSourceDefinition } from "@stovokor/shader/ShaderSourceCode"
import { UniformDynamic } from "@stovokor/shader/Uniform"
import { type StovokorContext } from "@stovokor/StovokorContext"

export class TextRenderer extends Renderer {
	private modelViewProjection = new UniformDynamic<matrix>()
	private modelMatrix = new UniformDynamic<matrix>()
	private lightDirection = new UniformDynamic<vec3>()
	private ambientStrength = new UniformDynamic<number>()

	constructor(context: StovokorContext, geometry: Geometry, material: Material, ambientStrength: number = 0.6) {
		super(context, new ShaderSourceDefinition("text_lit"), geometry, [material])
		this.ambientStrength.value = ambientStrength
	}

	protected stateUpdate(state: RenderState): void {
		this.modelViewProjection.value = state.modelViewProjection
		this.modelMatrix.value = state.modelMatrix
		this.lightDirection.value = RenderState.lightDirection
	}
}
